module.exports = __webpack_public_path__ + "img/PDF.5b548cd3.svg";